import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_batch_hdr_RowClass } from '../../../dbschema/bl_inv_batch_hdr.model';

export class BatchHdrModel extends BaseContainerModel {
  bl_inv_batch_hdr: bl_inv_batch_hdr_RowClass = new bl_inv_batch_hdr_RowClass();
}